import React from 'react'
import styled from '@emotion/styled';
import LeadImageOrVideo from 'routes/articleshow_v2/components/common/LeadImageOrVideo';
import _get from 'lodash.get';
import { StyledImage, ImageCaption } from '../../../../components/Print/StyledImage';
import { PlayIcon } from '../../../../components/Print/PlayIcon';
import { TOI_DEFAULT_IMAGE_MSID } from 'constants/index';
import s from './PrintArticle.scss'

interface IPrintArticleImageProps {
  articleShowData: { [key: string]: any }
  isWapView: boolean
  scrollToBlocker: (() => void) | undefined
  isUserPrime: boolean
}

function PrintArticleImage(props: IPrintArticleImageProps) {
  const { articleShowData, isWapView, isUserPrime } = props;
  const isExplainerArticle = _get(articleShowData, `metaInfo.NatureOfContent`, '').toLowerCase() === 'explainer';
  const getNonPrimeImage = () => {
    const { images } = articleShowData;
    if (!(Array.isArray(images) && images.length)) {
      return null;
    }
    const defaultImage = images[0];
    const webImage = images?.find(
      (el: { [key: string]: any }) => el?.payload?.toLowerCase() === 'OverrideLeadImage'.toLowerCase(),
    );
    if (isWapView) return defaultImage;
    if (articleShowData.metaInfo?.Hideheadline === '1') {
      return webImage || defaultImage;
    }
    return webImage || defaultImage;
  };

  const getImage = () => {
    const imgObj = getNonPrimeImage();
    return (
      imgObj && imgObj.id && imgObj.id !== TOI_DEFAULT_IMAGE_MSID ? <>
        <StyledImageWrapper>
          <StyledImage type='nonprime'
            src={`https://static.toiimg.com/thumb/${imgObj?.imagesize ? `imgsize-${imgObj.imagesize}` : ''
              },msid-${imgObj?.id},width-800,resizemode-4/${imgObj?.id}.jpg`}
            alt=""
          />
          {articleShowData.hasVideo && <PlayIconWrapper><PlayIcon /></PlayIconWrapper>}
        </StyledImageWrapper>
        {imgObj.cap ? <ImageCaption margin={'8px'}>{imgObj.cap}</ImageCaption> : null}
      </> : null
    );
  }

  const getPrimeImage = () => {
    let leadImageHtml = null;
    if (articleShowData.videos && articleShowData.videos.length > 0
    ) {
      leadImageHtml = (
        <>
          <LeadImageOrVideo
            hl={articleShowData.hl}
            artilceMsid={articleShowData.id}
            video={articleShowData.videos[0]}
            videoImageId={
              articleShowData.imageid && articleShowData.imageid.length
                ? articleShowData.imageid.split('&')[0]
                : ''
            }
            highlight={articleShowData.hlts}
            highlightCdata={articleShowData.hltsCdata}
            isWapView={isWapView}
            styleObj={s}
            isUserPrime={isUserPrime}
            videoCaption={
              articleShowData.images && articleShowData.images[0]
                ? articleShowData.images[0].cap
                : ''
            }
            widgets={articleShowData.widgets}
            isArticleshow
            bottom={650}
            isExplainerArticle={isExplainerArticle}
            printLayout
          />
        </>
      );
    } else if (articleShowData.images && articleShowData.images.length === 1 && articleShowData.images[0].id && articleShowData.images[0].id !== TOI_DEFAULT_IMAGE_MSID) {
      leadImageHtml = (
        <>
          <LeadImageOrVideo
            hl={articleShowData.hl}
            image={articleShowData.images[0]}
            highlight={articleShowData.hlts}
            isWapView={isWapView}
            highlightCdata={articleShowData.hltsCdata}
            isUserPrime={isUserPrime}
            widgets={articleShowData.widgets}
            isArticleshow
            bottom={650}
            isExplainerArticle={isExplainerArticle}
            syn={articleShowData.syn}
            styleObj={s}
            printLayout
          />
        </>
      );
    } else if (articleShowData.images && articleShowData.images.length > 1) {
      const { images } = articleShowData;
      leadImageHtml = (
        <>
          <LeadImageOrVideo
            hl={articleShowData.hl}
            imgList={images}
            highlight={articleShowData.hlts}
            isWapView={isWapView}
            highlightCdata={articleShowData.hltsCdata}
            isUserPrime={isUserPrime}
            widgets={articleShowData.widgets}
            isArticleshow
            bottom={650}
            isExplainerArticle={isExplainerArticle}
            syn={articleShowData.syn}
            styleObj={s}
            printLayout
          />
        </>
      );
    }
    return leadImageHtml
  }
  return (
    <>
      {isUserPrime ? getPrimeImage() : getImage()}
    </>
  )
}

export default PrintArticleImage

const StyledImageWrapper = styled.section`
  margin: 20px 0 0 0;
  position: relative;
`
const PlayIconWrapper = styled.section`
  position: absolute;
  left: 0px;
  bottom: 0;
  
`